











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddTeamMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PublicTeamsFrag_team"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NewTeamForm_teams"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingsDashActiveMeetings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Team_team"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityDetailsSidebar_teams"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddTeamPayload",
  "abstractKey": null
};

(node ).hash = "76b37e06625359e5b70548f2782f595c";

export default node;
